import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { UserProfileComponent } from 'src/app/shared/components/user-profile/user-profile.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { UserType } from 'src/app/shared/constants/user-type.enum';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService } from '../../../providers/storage.service';

@Component({
  selector: 'sm-latest-businesses',
  templateUrl: './latest-businesses.component.html',
  styleUrls: ['./latest-businesses.component.scss']
})
export class LatestBusinessesComponent implements OnInit {

  businessList: any[] = [];
  count: number = 0
  imageThumbUrl: string = environment.profileImageBaseUrl;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "entityName"
    },
    {
      columnName: "location",
      columnProperty: "addressInfo"
    },
    {
      columnName: "status",
      columnProperty: "isActive"
    }
  ];
  private _apiSubscription: Subscription;

  constructor(private _storageService: StorageService,private _apiService: ApiService, private _dialog: MatDialog, private router: Router, private route: ActivatedRoute) {
    // this.businessList = USERS_LIST;
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_ALL_ENTITY_DETAILS_RESULT){
        console.log(resData);
        resData.result.length = 10
        this.businessList = resData.result ? resData.result : [];
        console.log( this.businessList);
        this.businessList.forEach((item )=> {
          if(item.addressInfo && item.addressInfo!= null){
            item.addressInfo = (JSON.parse(item.addressInfo)).address_line
          }
          if(item.isActive == '2' ||item.isActive == '3' ){
            item.isActive = 'Deleted'
          }
          if(item.isActive == '1'){
            item.isActive = 'Active'
          }
          if(item.isActive == '0'){
            item.isActive = 'Deactive'
          }
         
        })
            console.log( this.businessList);
        
      }
     
    });
  }

  ngOnInit(): void {
  }

  viewProfile(profileData: any){
    this._dialog.open(UserProfileComponent, {
      data: profileData,
      maxWidth: 370,
      panelClass: 'user-profile-dialog'
    });
  }
  viewBusiness(value: any){
    console.log("click");
    this._storageService.setValueInAppStorage('specificEntityHash', value.hashId)
    this._storageService.setValueInAppStorage('specificEntityName', value.name)
    this.router.navigate(['users','entity-business'], {relativeTo: this.route})
    
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

}
